angular.module('autoremind.reports.communication')
    .directive('reportsMissed', ['$rootScope', '$location', 'userProfile',
    function ($rootScope, $location, userProfile) {
        return {
            templateUrl: 'app/reports/communication/missed/missed.html',
            scope: true,
            link: function (scope, elem, attr) {
                userProfile.initalizeViewModel();
                userProfile.getProfileIfNotLoaded(function () {
                    console.debug('reportsMissed: got user profile');
                });
                if (userProfile.viewModel.views.reportsMissed === undefined) {
                    userProfile.viewModel.views.reportsMissed = {};
                }
                scope.viewModel = userProfile.viewModel.views.reportsMissed;
                scope.viewModel.loadingIndicator = {
                    refCount: 0,
                    state: false
                };
                scope.viewModel.successful = [];
                scope.viewModel.inProgress = [];
                scope.viewModel.unsuccessful = [];
                scope.viewModel.viewMessages = false;
                scope.viewModel.selectedFilter = null;
                scope.viewModel.totalMessages = 0;
                $rootScope.$on('event:auth-loginConfirmed', function () {
                    $location.search('jobid', null);
                });
            }
        };
    }]);
//# sourceMappingURL=missed.directive.js.map